var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2381 16.7619C17.2381 14.132 19.3701 12 22 12C24.6299 12 26.7619 14.132 26.7619 16.7619V18.9048C26.7619 19.9673 26.4139 20.9486 25.8256 21.7409L30.3315 24.5779C31.37 25.2318 32 26.373 32 27.6002V28.4286C32 30.401 30.401 32 28.4286 32H15.5714C13.599 32 12 30.401 12 28.4286V27.6002C12 26.373 12.6301 25.2318 13.6685 24.5779L17.395 22.2316C18.0956 23.3444 17.7615 24.8145 16.6487 25.5151L14.9371 26.5928C14.591 26.8107 14.381 27.1911 14.381 27.6002V28.4286C14.381 29.0861 14.9139 29.619 15.5714 29.619H28.4286C29.0861 29.619 29.619 29.0861 29.619 28.4286V27.6002C29.619 27.1911 29.409 26.8107 29.0629 26.5928L23.8342 23.3006C23.2696 23.5364 22.65 23.6667 22 23.6667C19.3701 23.6667 17.2381 21.5347 17.2381 18.9048V16.7619ZM19.619 16.7619C19.619 15.4469 20.685 14.381 22 14.381C23.315 14.381 24.381 15.4469 24.381 16.7619V18.9048C24.381 20.2197 23.315 21.2857 22 21.2857C20.685 21.2857 19.619 20.2197 19.619 18.9048V16.7619Z",
    fill: "#47475F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.dd9c9907.svg";
export { ForwardRef as ReactComponent };